import React from "react";
import Button from "../inputs/Button";
import Dropdown from "../inputs/Dropdown";
import Input from "../inputs/Input";
import FileUpload from "../shared/FileUpload";
import Modal from "../shared/Modal";
import ProgressBar from "../shared/ProgressBar";
import Textarea from "../shared/Textarea";

const DocumentUploadModal = ({
  isOpen,
  onClose,
  newDocument,
  setNewDocument,
  onUpload,
  isUploading,
  uploadProgress,
}) => {
  const documentTypes = [
    { value: "PDF", label: "PDF" },
    { value: "Word", label: "Word Document" },
    { value: "Excel", label: "Excel Spreadsheet" },
    { value: "Image", label: "Image" },
    { value: "Other", label: "Other" },
  ];

  const handleFileSelect = (file) => {
    setNewDocument({
      ...newDocument,
      file,
      name: newDocument.name || file.name.split(".")[0],
    });
  };

  const handleClose = () => {
    if (!isUploading) {
      setNewDocument({ name: "", type: "PDF", description: "", file: null });
      onClose();
    }
  };

  const footer = (
    <div className="flex justify-end space-x-3">
      <Button variant="outline" onClick={handleClose} disabled={isUploading}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onUpload} disabled={isUploading}>
        {isUploading ? "Uploading..." : "Upload Document"}
      </Button>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Upload Document"
      size="md"
      footer={footer}
      closeOnBackdrop={!isUploading}
    >
      <div className="space-y-4">
        <Input
          label="Document Name"
          name="documentName"
          placeholder="e.g., Technical Analysis Report"
          required
          field={{
            value: newDocument.name,
            onChange: (value) =>
              setNewDocument({ ...newDocument, name: value }),
          }}
        />

        <Dropdown
          headLabel="Document Type"
          label="Select document type"
          options={documentTypes}
          value={newDocument.type}
          onSelect={(value) => setNewDocument({ ...newDocument, type: value })}
          disabled={isUploading}
        />

        <Textarea
          label="Description (Optional)"
          name="description"
          placeholder="Brief description of the document..."
          rows={3}
          value={newDocument.description}
          onChange={(e) =>
            setNewDocument({ ...newDocument, description: e.target.value })
          }
          disabled={isUploading}
        />

        <FileUpload
          onFileSelect={handleFileSelect}
          accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
          maxSize={10 * 1024 * 1024}
          currentFile={newDocument.file}
          disabled={isUploading}
          helperText="PDF, DOC, DOCX, XLS, XLSX, PNG, JPG (max 10MB)"
        />

        {isUploading && (
          <div className="pt-2">
            <ProgressBar value={uploadProgress} label="Uploading" />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DocumentUploadModal;
